import { Layers } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePiecesPerBundleUnit } from '~/hooks/usePiecesPerBundleUnit';

type PiecesPerBundleLabelProps = {
  piecesPerBundle: number;
  linePieces: number;
};

export function PiecesPerBundleLabel({
  piecesPerBundle,
  linePieces,
}: Readonly<PiecesPerBundleLabelProps>) {
  const { t } = useTranslation('cart');
  const unit = usePiecesPerBundleUnit();

  if (piecesPerBundle <= 0) {
    return (
      <p
        data-testid="pieces-per-bundle-label"
        className="text-xs text-warning-500 mt-1 flex items-center gap-1"
      >
        <Layers size={12} aria-hidden="true" />
        {t('cart.no_pieces_per_bundle', { unit })}
      </p>
    );
  }

  return (
    <p
      data-testid="pieces-per-bundle-label"
      className="text-xs text-neut-sec mt-1 flex items-center gap-1 whitespace-nowrap"
    >
      <Layers size={12} aria-hidden="true" />
      <span>
        {piecesPerBundle} {unit}
        {linePieces > 0 && (
          <>
            {' · '}
            <strong>{linePieces} PCS</strong>
          </>
        )}
      </span>
    </p>
  );
}
